import React from 'react';
import { createPortal } from 'react-dom';
import styles from './bookedCard.module.css';
import Modal from '@/ctComponents/Modal';
import Card from './Card';
import LoadingV2 from '@/components/Loading';

const AppointmentHistory = ({
  show,
  history,
  terminalId,
  onClose,
  loading,
  container,
}) => {
  return createPortal(
    <Modal
      show={show}
      minWidth={'unset'}
      children={
        <div className="h-full overflow-x-hidden">
          <div className={styles.ModalTitle}>
            View your appointment activities for {container} and keep track of
            any changes here.
          </div>

          <div className="overflow-x-auto">
            <div
              className={styles.historyList}
              style={{
                paddingRight: history?.length > 3 ? '12px' : '8px',
              }}>
              {loading ? (
                <LoadingV2 />
              ) : (
                history?.map((appointmentSet, index) => (
                  <>
                    <div className={styles.circleContainer}>
                      <div className={styles.circle} />
                      <span>
                        {appointmentSet?.action_at &&
                          new Date(appointmentSet?.action_at)
                            .toLocaleString(undefined, {
                              month: 'short',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                              hour12: false,
                            })
                            .replace(',', ' at')}
                      </span>
                    </div>
                    <div>
                      <div
                        className={styles.row}
                        style={{
                          borderLeftColor:
                            index + 1 === history?.length
                              ? 'transparent'
                              : '#E8E8E8',
                        }}>
                        <Card
                          terminal={appointmentSet?.terminal?.slug.replace(
                            /\s+/g,
                            ''
                          )}
                          date={appointmentSet?.date?.replace(
                            /(\d{4})-(\d{2})-(\d{2})/,
                            '$2/$3/$1'
                          )}
                          time={`${appointmentSet?.time_start} - ${appointmentSet?.time_end}`}
                          license_plate={appointmentSet?.license_plate}
                          type={
                            appointmentSet?.type !== 'SINGLE'
                              ? 'Dual'
                              : 'Single'
                          }
                          status={appointmentSet?.status}
                          statusText={appointmentSet?.status_text}
                          width={'550px'}
                          fromAutobook={appointmentSet?.from_autobook}
                          originSource={appointmentSet?.origin_source}
                          terminalId={terminalId.replace('key_', '')}
                          lastMessage={appointmentSet?.message}
                          tooltipSuffix={`h-${index}`}
                          data={[appointmentSet]}
                          history={[]}
                          loadingHistory={false}
                          showHistory={() => {}}
                          setShow={() => {}}
                          fromModal
                        />
                      </div>
                    </div>
                  </>
                ))
              )}
            </div>
          </div>
        </div>
      }
      icon={'history'}
      title={'Appointment History'}
      setShow={onClose}
      notClose={false}
    />,
    document.body
  );
};

export default AppointmentHistory;
